module.exports = __webpack_public_path__ + "82e12b6a3240622afc6681caec8a3752.png";